module.exports = __webpack_public_path__ + "media/images/logo-login@3x-d395613e01a3685204c96aae3802a1aa.png";